<template>
  <div class="content">
    <div class="con_bg">
      <!--专题介绍 -->
      <div class="activity">
        <div class="actTit">
          <div class="titImg">
            <img :src="titImg" />
          </div>
        </div>
      </div>

      <div class="mainCon">
        <div class="main">

          <ul class="booklist" id="list">
            <li class="bookLi" v-for="(item,index) in bookList" :key="index">
              <div class="bookLi1">
                <div class="bookImg">
                <a :href="item.url" target="_blank">
                  <img :src="item.cover" />
                </a>
              </div>
              <div class="bookInfor">
                <h3 class="bookName">
                  <a :href="item.url" target="_blank">{{item.name}}</a>
                </h3>
                <p class="author">{{item.author}}</p>
                <p style="font-size:0.16rem;margin-bottom:0.2rem;height:0.3rem;">{{item.chuban}}</p>
                <p>
                  <a :href="item.url" target="_blank" class="btn">立即阅读</a>
                </p>
              </div>
              </div>
              <div class="jianjie">内容简介</div>
              <div class="intro">{{item.intro}}</div>
            </li>
          </ul>
          <div class="z1"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bookList } from "../../assets/js/data";
export default {
  name: "content",
  data() {
    return {
      returnUrl: "/static-topic/007/index_pc.html&boot=false",
      contentBg: require("../../assets/img/pc/mbg.png"),
      titImg: require("../../assets/img/pc/text2.png"),
      titImg1: require("../../assets/img/pc/biaoti1.png"),
      titImg2: require("../../assets/img/pc/pic1.png"),
      titImg3: require("../../assets/img/pc/biaoti2.png"),
      titImg4: require("../../assets/img/pc/biaoti3.png"),
      gobtn: require("../../assets/img/pc/btn.png")
    };
  },
  computed: {
    bookList() {
      return bookList;
    }
  },
  methods: {
    getUrl() {}
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.content {
  width: 100%;

  // margin: 0 auto;
  // position: relative;
  position: absolute;
  // top: 3.5rem;
  .con_bg {
    width: 12rem;
    margin: -6rem auto;
    background: #fff;

    border-radius: 20px;
    padding: 0.6rem;
  }

  .activity {
    width: 100%;
    margin-bottom: 0.3rem;
    .actTit {
      width: 100%;
      .titImg {
        width: 2.25rem;
        margin: 0 auto;
        margin-bottom: 0.6rem;
        img {
          width: 100%;
          height: 0.29rem;
        }
      }

      .text {
        padding: 0 0.2rem;
        line-height: 0.4rem;
        color: #405656;
      }
    }
  }
  .htitle {
    margin-bottom: 0.25rem;
    img {
      width: 2.93rem;
    }
  }
  .info {
    margin-bottom: 0.3rem;
    img {
      width: 2.93rem;
    }
    .dec {
      width: 100%;
      .prize {
        height: 2.14rem;
        margin-bottom: 0.26rem;
        img {
          width: 2.14rem;
          height: 2.14rem;
        }
      }

      p {
        margin-bottom: 0.2rem;
        // color: #de0027;
        font-size: 0.2rem;
      }
      .level {
        font-size: 0.22rem;
        font-weight: bold;
        color: #e10a30;
      }
      .name {
        color: #e10a30;
      }
      .sm {
        margin-bottom: 0.3rem;
        font-size: 0.16rem;
        color: #e10a30;
      }
      .activeDec {
        text-align: left;
        margin-bottom: 0.4rem;
        h3 {
          font-size: 0.28rem;
          margin-bottom: 0.2rem;
        }
        p {
          margin: 0;
          line-height: 0.4rem;
        }
        .bold {
          font-weight: bold;
          width: 1rem;
          display: inline-block;
        }
      }
    }
    .gobtn {
      display: inline-block;
      height: 0.64rem;
      margin-bottom: 0.4rem;
      img {
        width: 2.5rem;
        height: 0.64rem;
      }
    }
    .mark {
      padding: 0 0.3rem;
      line-height: 0.38rem;
      text-align: left;
      color: #de0027;
    }
  }

  .booklist {
    // padding: 0.4rem 0.35rem;
 
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      width: 5.2rem;
      // display: flex;
      margin-bottom: 0.32rem;
      background: #FCF3DF;
      padding: 0.3rem;
      box-sizing: border-box;
          .bookLi1{
      width: 100%;
   display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom:0.2rem ;
    }
            .intro {
          height: 0.87rem;
          font-size: 0.16rem;
          line-height: 0.3rem;
          margin-bottom: 0.14rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
          color: #666666;
        }
        .jianjie{
          color: #333333;
          text-align: left;
          font-size: 0.16rem;
          font-weight: bold;
          margin-bottom:0.1rem ;
        }
      .bookImg {
        width: 1.74rem;
        height: 2.32rem;
        margin-right: 0.2rem;
        a {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .bookInfor {
        flex: 1;
        color: #666666;
        text-align: left;
        
        .bookName {
          font-size: 0.2rem;

          font-weight: bold;
          color: #333333;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
          a {
            color: #333333;
          }
        }
        .author {
          font-size: 0.16rem;
          line-height: 0.6rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }


        .btn {
          font-size: 0.16rem;
          display: inline-block;
          width: 1.3rem;
          height: 0.4rem;
          line-height: 0.4rem;
          text-align: center;
          background: #904E1C;
          border-radius: 4px;
          color: #fff;
        }
      }
    }
  }
}
</style>
